export const FUTURE_VALUES_PER_SHARE_TABLE_NAME = 'Future Values per Share';
export const FUTURE_VALUES_PER_SHARE_TABLE_SLUG = 'future-values-per-share';
export const PRESENT_VALUES_PER_SHARE_TABLE_NAME = 'Present Values per Share';
export const PRESENT_VALUES_PER_SHARE_TABLE_SLUG = 'present-values-per-share';
export const VALUES_PER_SHARE_SPREADSHEET_COLUMN_KEY_PREFIX = 'security';
export const VALUES_PER_SHARE_SPREADSHEET_HEADER = 'VALUES_PER_SHARE_SPREADSHEET_HEADER';
